import { Image } from "./image.js";
import { ImageStyles, ImageTemplate } from "@fluentui/web-components";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Image component.
 *
 * @public
 */
export const definition = Image.compose({
    name: `${DesignSystem.prefix}-image`,
    template: ImageTemplate,
    styles: ImageStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=image.definition.js.map